import { sendWebsocketMessage } from '../../../../../../App';

export function flattenTradePlan(tradePlanId) {

  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    value: tradePlanId,
    field: 'flatten',
  };
  sendWebsocketMessage(msg);
}
